module.exports = __webpack_public_path__ + "img/kc_logo.795ced68.png";